// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"map-checked"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M15 6.5L9 3L3 6.5V20L9 17.5M15 6.5L21 4V11M15 6.5V11M9 17.5V3.5M9 17.5L10.5 18.375","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M13.7578 17.4144L16.5862 20.2428L22.2431 14.5859","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const MapCheckedIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'map-checked',
    ref,
    icon: element,
  },
));

MapCheckedIcon.displayName = 'MapCheckedIcon';

export default MapCheckedIcon;
